import React, { forwardRef } from 'react';
import { Stack, Typography} from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert'
import { grey } from '@mui/material/colors'


const Alert = forwardRef(function Alert(
    props,
    ref,
) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
})


// interface IProps {
//     onBack: (value : any) => void
//     title: any
//     severity:any
//     viewNoti: boolean
// }

export default function Notification({title, severity, viewNoti, onBack}) {
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return
        }

        onBack(false);
    };

    return (
        <Stack spacing={2} sx={{ width: '100%' }}>
            <Snackbar 
                open={viewNoti} 
                autoHideDuration={5000} 
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right"
                }} 
                >
                <Alert 
                    onClose={handleClose} 
                    severity={severity} 
                    sx={{ width: '100%' }}
                    >
                    <Typography 
                        fontFamily='b_mitra' 
                        component="span"
                        variant="h6"
                        color={grey[100]}
                        >
                        {title}
                    </Typography>
                </Alert>
            </Snackbar>
            {/* <Alert severity="error">This is an error message!</Alert>
            <Alert severity="warning">This is a warning message!</Alert>
            <Alert severity="info">This is an information message!</Alert>
            <Alert severity="success">This is a success message!</Alert> */}
        </Stack>
    );
}